import React from "react"
import grugHead from "images/love_irish/grug-head.png"
import Tooltip from "design_system/core/components/tooltip"

/**
 * A "Grug tip": a short, keep-it-simple learning aside spoken by Grug, the goblin sidekick. Grug
 * follows the grug-brain developer ethos, simplicity is a feature, so his tips cut a scary-looking
 * rule down to the one thing a beginner should actually do. His illustration anchors him as a
 * recurring character across the learning material.
 *
 * @example
 * <GrugTip>grug not learn every rule first. grug say word out loud, fix later.</GrugTip>
 */
export const GrugTip: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div
    className="my-4 rounded border-2 border-warning bg-warning-50/75 p-2"
    data-testid="grug-tip"
  >
    <div className="flex gap-1">
      <div className="text-sm">
        <span className="font-bold">Grug tip</span>{" "}
        <span className="text-muted-foreground">{children}</span>
      </div>

      {/* The tooltip portals to <body>; the shared .tooltip z-index sits above the modal overlay so it
          is not hidden/blurred. Do not add a z-* class here (it would override that and re-break it). */}
      <Tooltip
        title="Grug's tips for keeping language learning simple"
        wrapperClass="-ml-4 -mt-4 w-[90px] shrink-0 self-start"
      >
        <img src={grugHead} alt="Grug" className="" />
      </Tooltip>
    </div>
  </div>
)

export default GrugTip
